import { axiosInstance } from "../../../api/axiosInstance";
import { DemoRequestData } from "../types";

export const demoService = {
  requestDemo(payload: DemoRequestData) {
    return axiosInstance.post("/public/demo/request", payload);
  },
};
